import { render } from "./SubscriptionPaymentResult.vue?vue&type=template&id=056795aa&scoped=true"
const script = {}

import "./SubscriptionPaymentResult.vue?vue&type=style&index=0&id=056795aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056795aa"]])

export default __exports__